import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInvisible = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21.8322 10.5547C22.1385 10.0951 22.0143 9.47427 21.5548 9.16792C21.0953 8.86158 20.4744 8.98577 20.168 9.4453C18.329 12.2039 15.3929 14.0001 12 14.0001C8.60728 14.0001 5.67115 12.2039 3.83214 9.44554C3.52578 8.98601 2.90491 8.86185 2.44539 9.16822C1.98587 9.47458 1.86171 10.0954 2.16807 10.555C2.99086 11.7891 4.01152 12.8728 5.18888 13.7418L4.14262 15.4855C3.85847 15.9591 4.01202 16.5733 4.4856 16.8575C4.95917 17.1416 5.57344 16.9881 5.85759 16.5145L6.89239 14.7899C8.14736 15.4212 9.52861 15.829 11.0001 15.9569V18C11.0001 18.5523 11.4478 19 12.0001 19C12.5524 19 13.0001 18.5523 13.0001 18V15.9569C14.4716 15.8289 15.8529 15.4211 17.1078 14.7898L18.1426 16.5145C18.4268 16.9881 19.041 17.1416 19.5146 16.8575C19.9882 16.5733 20.1417 15.9591 19.8576 15.4855L18.8113 13.7417C19.9887 12.8727 21.0094 11.7889 21.8322 10.5547Z",
		fill: "currentColor"
	})
});
export default SvgInvisible;
